export type PostalAddressInput = {
  streetAddress?: string | null;
  addressLocality?: string | null;
  postalCode?: string | null;
  addressRegion?: string | null;
  addressCountry?: string | null;
};

/**
 * Google Search Console flags warnings when `PostalAddress` exists but lacks recommended fields.
 * To permanently eliminate those warnings, we only emit `PostalAddress` when we have:
 * - streetAddress
 * - addressLocality
 * - postalCode
 */
export const buildPostalAddressStrict = (data: PostalAddressInput) => {
  const streetAddress = data.streetAddress?.trim();
  const addressLocality = data.addressLocality?.trim();
  const postalCode = data.postalCode?.trim();
  const addressRegion = data.addressRegion?.trim();

  if (!streetAddress || !addressLocality || !postalCode) return undefined;

  return {
    "@type": "PostalAddress",
    streetAddress,
    addressLocality,
    postalCode,
    ...(addressRegion ? { addressRegion } : {}),
    addressCountry: (data.addressCountry?.trim() || "ES"),
  };
};
